import { render, staticRenderFns } from "./InfluencerProfileReviewsTab.vue?vue&type=template&id=63a46844"
import script from "./InfluencerProfileReviewsTab.vue?vue&type=script&lang=js"
export * from "./InfluencerProfileReviewsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports